import React, { FC } from 'react';
import styles from './BigWins.module.scss';
import { CardWrapper } from '../../../components/CardWrapper/CardWrapper';
import { PropertyType } from 'esa-ui-library/lib/types';
import { BigWinItem } from './BigWinItem/BigWinItem';

interface BigWinsProps {
	data: PropertyType[];
}

const BigWins: FC<BigWinsProps> = ({ data }) => (
	<CardWrapper backgroundColor='#1E272E' className={styles.Wrapper}>
		<h4 className={styles.Title}>Big Wins</h4>
		<section className={styles.List}>
			{data.map((item) => (
				<BigWinItem key={item.game_id} data={item} />
			))}
		</section>
	</CardWrapper>
);

export { BigWins };
